import * as Auth from './auth';

export default Auth;
